:host {
  max-width: 100%;
  background-color: var(--white-layout-301-level-0-elevation);
}

.push-body {
  &--menu {
    display: none;
  }
}

.push-body,
.push-body--content {
  height: 100%;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  height: 64px;
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 2.5) calc(var(--spacer) * 3) calc(var(--spacer) * 2.5);

  &--top {
    display: flex;
    justify-content: space-between;
  }
}

.title {
  color: var(--body-text-arrows-400);
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  gz-grid-view {
    align-items: stretch;
    min-height: 100%;
  }
}

gz-push-body-layout[resizable][isopen]::part(header) {
  margin-bottom: calc(2 * var(--spacer));
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
  text-transform: uppercase;
}

gz-push-body-layout[resizable][isopen]::part(sideNav) {
  min-width: 240px;
}
